import { Fragment, useEffect, useState } from "react";
import Button from "./components/UI/Button";
import MaaltijdenForm from "./components/MaaltijdenForm";
import MaaltijdenFormUpdate from "./components/MaaltijdenFormUpdate";
import Card from "./components/UI/Card";
import Section from "./components/UI/Section";
import Main from "./components/UI/Main";
import "./App.css";

const App = () => {
  const [maaltijden, setMaaltijden] = useState([]);
  const [aanpassen, setAanpassen] = useState(false);
  const [onderhandenId, setOnderhandenId] = useState("");

  useEffect(() => {
    fetch("https://www.marchouben.nl/php/maaltijden-get.php")
      .then((response) => response.json())
      .then((data) => {
        setMaaltijden(data);
      });
  }, []);

  const deleteHandler = async function (id) {
    console.log("Verwijderen (id): " + id);

    setMaaltijden((prevMaaltijden) => {
      const updatedMaaltijden = prevMaaltijden.filter(
        (maaltijd) => maaltijd.id !== id
      );
      return updatedMaaltijden;
    });

    const response = await fetch(
      "https://www.marchouben.nl/php/maaltijden-delete.php",
      {
        method: "DELETE",
        body: JSON.stringify({
          id: id,
        }),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    const data = await response.json();
    console.log(data);
  };

  const insertHandler = async function (naam, omschrijving, prijs, datum) {
    const [ids] = [maaltijden];
    let index = ids.length;
    const id = +ids[index - 1].id + 1;
    console.log("Toevoegen (id): " + id);

    setMaaltijden((prevMaaltijdenList) => {
      return [
        ...prevMaaltijdenList,
        {
          id: id,
          naam: naam,
          omschrijving: omschrijving,
          prijs: prijs,
          datum: datum,
        },
      ];
    });

    const response = await fetch(
      "https://www.marchouben.nl/php/maaltijden-post.php",
      {
        method: "POST",
        body: JSON.stringify({
          id: id,
          naam: naam,
          omschrijving: omschrijving,
          prijs: prijs,
          datum: datum,
        }),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    const data = await response.json();
    console.log(data);
  };

  // PUT is a method of modifying resource where the client sends data that updates the entire resource .
  // PATCH is a method of modifying resources where the client sends partial data that is to be updated without modifying the entire data.
  const updateHandler = async function (id, naam, omschrijving, prijs, datum) {
    setAanpassen(true);
    console.log("Aanpassen (id): " + id);
    setOnderhandenId(id);

    const existingMaaltijdIndex = maaltijden.findIndex(
      (maaltijd) => maaltijd.id === id
    );

    const existingMaaltijd = maaltijden[existingMaaltijdIndex];
    console.log(existingMaaltijd);

    let updatedItems;

    const updatedItem = {
      ...existingMaaltijd,
      naam: naam,
      omschrijving: omschrijving,
      prijs: prijs,
      datum: datum,
    };
    console.log(updatedItem);
    updatedItems = [...maaltijden];
    updatedItems[existingMaaltijdIndex] = updatedItem;

    setMaaltijden((prevMaaltijdenList) => {
      return updatedItems;
    });

    const response = await fetch(
      "https://www.marchouben.nl/php/maaltijden-put.php",
      {
        method: "POST",
        body: JSON.stringify(updatedItem),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    const data = await response.json();
    console.log(data);
  };

  const toggleHandler = () => {
    setAanpassen(false);
  };

  // onClick verwacht een functie
  return (
    <Fragment>
      <div className="App">
        <Card className="meals">
          <h1>Maaltijden</h1>
          <Section>Stel je eigen menukaart samen</Section>
          <Main>
            <ul>
              {maaltijden.map((maaltijd) => (
                <li key={maaltijd.id}>
                  {maaltijd.naam} <br />
                  {maaltijd.omschrijving} <br />€{maaltijd.prijs} <br />
                  {maaltijd.datum} <br />
                  <Button
                    className="button-small"
                    onClick={() =>
                      updateHandler(
                        maaltijd.id,
                        maaltijd.naam,
                        maaltijd.omschrijving,
                        maaltijd.prijs,
                        maaltijd.datum
                      )
                    }
                  >
                    Aanpassen
                  </Button>
                  <Button
                    className="button-small"
                    onClick={() => deleteHandler(maaltijd.id)}
                  >
                    Verwijderen
                  </Button>
                </li>
              ))}
            </ul>
            {!aanpassen && <MaaltijdenForm onAddMaaltijd={insertHandler} />}
            {aanpassen && (
              <MaaltijdenFormUpdate
                onUpdateMaaltijd={updateHandler}
                id={onderhandenId}
                onToggle={toggleHandler}
                meals={maaltijden}
              />
            )}
          </Main>
        </Card>
      </div>
    </Fragment>
  );
};

export default App;
